import React from "react";
import { Box, TextareaAutosize } from "@material-ui/core";

const PrivacyPolicyCustomer = () => {
  const text = `
個人情報の取り扱いについて
ピッタプット運営会社の株式会社SORA（以下「当社」）は、お預かりした個人情報において、次のように管理し保護に努めて参ります。つきましては、本内容をご理解いただき、ご同意の程お願い申し上げます。

＜個人情報保護方針＞
当社は、お客様の個人情報保護、個人情報の適切な取り扱いを重要かつ社会的責務であると考え、以下の通り「個人情報保護方針」を定め、適切に運用致します。
1. 当社の事業および規模を考慮した適切な個人情報の取得、利用及び提供に関する社内規程を遵守します。
2. 当社が保有する個人情報に関して適用される法令、国が定める指針その他の規範を遵守いたします。
3. 個人情報の漏えい、滅失又はき損などに対して、防止及び是正対策を実施します。
4. 個人情報の取扱いに関するお客様からのご意見・ご相談・苦情等に対して適切に対応します。
5. 当社は、個人情報保護マネジメントシステムを確立し、定期的に見直し改善に努めます。
6. 取得した個人情報は後述する利用目的の範囲内でのみ利用し、これらの利用目的以外で利用する際は利用者に対し事前に確認または同意を得ます。

＜収集する個人情報と取得方法＞
ピッタプット（以下、本サービス）では商品の購入に際して以下の個人情報をお客様より入力していただき、それらを個人情報として扱います。
・氏名
・メールアドレス

＜個人情報の利用目的＞
・ご相談・お問い合わせへの適切な対応
・当社サービスの改善に役立てるため
・各商品（デジタルコンテンツ）をお客様に配信するため
・お客様の許諾に基づく、本サービス利用者（商品の出品者）に対する個人情報開示

＜個人情報の第三者提供＞
お客様の個人情報について、お客様本人の同意を得ずに、本サービス利用企業などの第三者に開示することは、原則いたしません。提供先・提供情報内容を特定したうえで、お客様の同意を得た場合に限り開示します。ただし以下の場合は、関係法令に反しない範囲で、お客様の同意なくお客様の個人情報を開示することがあります。

1. お客様が第三者に不利益を及ぼすと当社が判断した場合。
2. 人の生命、身体または財産の保護のために必要がある場合であって、お客様本人の同意を得ることが困難である場合。
3. 公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、お客様本人の同意を得ることが困難である場合。
4. 国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合。
5. 裁判所、検察庁、警察、弁護士会、消費者センターまたはこれらに準じた権限を有する機関から、個人情報についての開示を求められた場合。
6. お客様本人から明示的に第三者への開示または提供を求められた場合。
7. 法令により開示または提供が許容されている場合。

＜本サービス利用者への個人情報提供＞
お客様の同意を得て本サービス利用者（商品の出品者）への個人情報提供は下記にしたがって行います。
・目的：各利用者（出品者）のサービス向上
・提供する個人情報の項目：氏名、メールアドレス
・提供の方法：本サービス利用者が本サービスにアクセスしダウンロード（SSLを利用しています）。

＜改定＞
当社はプライバシーポリシーの内容を定期的に見直し、必要に応じ全部又は一部改定することがあります。この場合、変更後のプライバシーポリシーについては、当社が別途定める場合を除いて、本サイトに掲載した時から効力を生じるものとします。

制定：2020年6月24日`;

  return (
    <Box>
      <TextareaAutosize
        id="privacyPolicyCustomer"
        value={text}
        readOnly
        minRows={10}
        style={{ width: "100%", fontSize: "0.8em", lineHeight: "1.2em", padding: "8px" }}
      />
    </Box>
  );
};

export default PrivacyPolicyCustomer;